import * as React from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface Props {
  open: boolean;
  columnName: string;
  isSubmitting: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
}

export const ColumnRerunConfirmDialog: React.FC<Props> = ({
  open,
  columnName,
  isSubmitting,
  onConfirm,
  onOpenChange,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>Re-run column: {columnName}</DialogTitle>
        <DialogDescription>
          Pathfinder will run the latest prompt from the template for every completed snapshot in the collection. Each
          response is replaced, including manual edits. Columns that reference this column keep their current responses.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className="mt-2">
        <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button type="button" disabled={isSubmitting} onClick={onConfirm}>
          {isSubmitting ? "Starting…" : "Re-run column"}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
